export const RaceTypes = [
	"Kwalificatie",
	"Sprintrace",
	"Volledige race"
];